import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-search-input',
  standalone: true,
  imports: [],
  template: `
    <div class="search-container">
      <div class="search-input-wrapper">
        <svg
          class="search-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
        <input
          type="text"
          class="search-input"
          [placeholder]="placeholder"
          [value]="value"
          (input)="onChange($any($event.target).value)"
          [attr.aria-label]="placeholder" />
        @if (value) {
          <button
            class="clear-search-btn"
            (click)="onClear()"
            [attr.aria-label]="'Clear ' + placeholder">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        }
      </div>
    </div>
  `,
  styles: [
    `
      .search-container {
        flex: 1;
        max-width: 300px;
      }
      .search-input-wrapper {
        position: relative;
        display: flex;
        align-items: center;
      }
      .search-icon {
        position: absolute;
        left: 12px;
        color: #666;
      }
      .search-input {
        width: 100%;
        padding: 8px 12px 8px 40px;
        border: 1px solid #ddd;
        border-radius: 4px;
        font-size: 14px;
      }
      .clear-search-btn {
        position: absolute;
        right: 8px;
        background: none;
        border: none;
        cursor: pointer;
        padding: 4px;
      }
    `,
  ],
})
export class SearchInputComponent {
  @Input() value = '';
  @Input() placeholder = 'Search...';
  @Output() valueChange = new EventEmitter<string>();
  @Output() clear = new EventEmitter<void>();

  onChange(newValue: string): void {
    this.valueChange.emit(newValue);
  }

  onClear(): void {
    this.clear.emit();
  }
}
